import namespaceHelper from '@/shared/helpers/namespace-helper';
import Cloner from '@/shared/helpers/cloner';
import { namespace, AttachmentMutations } from './types';
import { getDefaultState } from './state';
import Vue from 'vue';

const _mutations = namespaceHelper.removeNamespace(namespace, AttachmentMutations);
const MAX_CACHED_THUMBNAILS = 50;
export default {
  [_mutations.RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [_mutations.SET_ATTACHMENTS](state, { key, attachments }) {
    key = key || 'attachments';
    Vue.set(state, key, attachments);
    const dbKey = 'db' + key.charAt(0).toUpperCase() + key.slice(1);
    Vue.set(state, dbKey, Cloner.deepClone(attachments));
  },
  [_mutations.SET_WARRANTY_ASIDE_ATTACHMENTS](state, { key, attachments }) {
    key = key || 'warrantyAsideAttachments';
    Vue.set(state, key, attachments);
    state.warrantyAsideAttachments = attachments;
  },
  [_mutations.SET_COUNT_OF_ATTACHMENTS](state, count) {
    state.numOfAttachmentsCount = count;
  },
  [_mutations.SET_ATTACHMENT_DESCRIPTION](state, attachment) {
    const index = state.attachments.map(a => a.attachmentId).indexOf(attachment.attachmentId);
    state.attachments[index].description = attachment.description;
  },
  [_mutations.SET_ATTACHMENT_INTERNAL_FLAG](state, payload) {
    var attachment = payload.attachment;
    var newFlagValue = payload.newFlagValue;
    const index = state.attachments.map(a => a.attachmentId).indexOf(attachment.attachmentId);
    state.attachments[index].internal = newFlagValue;
  },
  [_mutations.SET_THUMBNAIL](state, { attachmentId, thumbnail }) {
    const index = state.attachments.map(a => a.attachmentId).indexOf(attachmentId);
    if (index !== -1) {
      // Revoke old blob URL if it exists
      const oldThumbnail = state.attachments[index].thumbnail;
      if (oldThumbnail && oldThumbnail.startsWith('blob:')) {
        URL.revokeObjectURL(oldThumbnail);
      }

      // If cache is full, remove oldest entries
      const cachedCount = state.attachments.filter(a => a.thumbnail).length;
      if (cachedCount >= MAX_CACHED_THUMBNAILS) {
        // Find and remove oldest cached thumbnail (FIFO)
        const oldestCached = state.attachments.find(a => a.thumbnail && a.attachmentId !== attachmentId);
        if (oldestCached && oldestCached.thumbnail.startsWith('blob:')) {
          URL.revokeObjectURL(oldestCached.thumbnail);
          Vue.set(oldestCached, 'thumbnail', null);
        }
      }

      Vue.set(state.attachments[index], 'thumbnail', thumbnail);
      Vue.set(state.dbAttachments[index], 'thumbnail', thumbnail);
    }
  }
};
